<template>
  <div class="client-list" :class="view_position">
    <div class="heading-small">Clients</div>

    <div class="client-type-flag mb-8">ACTIVE</div>

    <div class="clients">
      <div class="client" v-for="client in active_clients">
        <div class="client-name pointer" @click="showClient(client)">
          <div class="name subheading">{{ client.name }}</div>
          <div class="expand">
            <i class="fas fa-chevron-right"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="divider mt-8"></div>

    <div class="client-type-flag mt-16 mb-8">INACTIVE</div>

    <div class="clients">
      <div class="client" v-for="client in inactive_clients">
        <div class="client-name pointer" @click="showClient(client)">
          <div class="name subheading">{{ client.name }}</div>
          <div class="expand">
            <i class="fas fa-chevron-right"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    this.$root.$on('ClientList::show', () => {
      this.move('')
      this.$tpNav.scrollTop()
    })

    this.$root.$on('ClientList::move', (to) => {
      this.move(to)
    })

    this.$root.$on('ClientList::reload', () => {
      this.loadClients()
    })

    this.$root.$on('ManagerFilter::selected-manager', manager => {
      this.selected_manager = manager
      this.loadClients()
    })

    this.loadClients()
  },
  data() {
    return {
      active_clients: null,
      inactive_clients: null,
      view_position: '',
      selected_manager: null,
    }
  },
  methods: {
    showClient(client) {
      this.$root.$emit('TaskPoolNav::to-client', client)
      this.move('left-100')
      this.$root.$emit('ClientProjects::show', client)
    },
    move(to) {
      this.view_position = to
    },
    loadClients() {

      let token = this.$requestManager.newRequest('client-list-request')

      let params = {
        manager_id: this.selected_manager ? this.selected_manager.id : null
      }
      this.axios.get('/n/clients-for-task-pool', {
        params,
        cancelToken: token,
      }).then(response => {
        this.active_clients = response.data.active_clients
        this.inactive_clients = response.data.inactive_clients
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/agenda-v2/task-pool/client-list.vue